export enum TreeProductSource {
	Portal = 'Portal',
	Shopify = 'Shopify',
	BigCommerce = 'BigCommerce',
	Fulfill = 'Fulfill',
	Lightspeed = 'Lightspeed',
	ApparelMagic = 'ApparelMagic',
}
